module.exports = __webpack_public_path__ + "static/img/cs.450b195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cs.png
// module id = cbHU
// module chunks = 1